import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.mockUrl;
  }

  getAllPayments(body: any) {
    const link = this.apiUrl + ApiUrls.getPayments;
    return this.http.post<any>(link, body);
  }

  getPayment(id: any) {
    const link = this.apiUrl + ApiUrls.getPayment;
    return this.http.post<any>(link, { id });
  }

  deletePayment(id: any) {
    const link = this.apiUrl + ApiUrls.deletePayment;
    return this.http.post<any>(link, { id });
  }
}
